export default "__VITE_ASSET__CBUIv6SK__"